
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#" className="flex items-center">
              <img 
                src="https://centrourologicoguadalajara.com/logo.png"
                alt="UroMás Centro Urológico de Guadalajara - Logo"
                className="h-10 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Inicio
            </a>
            <a href="#tratamientos" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Tratamientos
            </a>
            <a href="#procedimientos" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Procedimientos
            </a>
            <a href="#nosotros" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Nosotros
            </a>
            <a href="#ubicaciones" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Ubicaciones
            </a>
            <a href="#contacto" className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer">
              Contacto
            </a>
          </nav>

          {/* Contact Button */}
          <div className="hidden md:flex">
            <a
              href="tel:+523318648274"
              className="bg-[#1B84FF] text-white px-6 py-2 rounded-lg hover:bg-[#0B2A4A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Agendar Cita
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#1B84FF] focus:outline-none"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-100 py-4">
            <nav className="flex flex-col space-y-4">
              <a 
                href="#inicio" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Inicio
              </a>
              <a 
                href="#tratamientos" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Tratamientos
              </a>
              <a 
                href="#procedimientos" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Procedimientos
              </a>
              <a 
                href="#nosotros" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Nosotros
              </a>
              <a 
                href="#ubicaciones" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Ubicaciones
              </a>
              <a 
                href="#contacto" 
                className="text-gray-700 hover:text-[#1B84FF] transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Contacto
              </a>
              <a
                href="tel:+523318648274"
                className="bg-[#1B84FF] text-white px-6 py-2 rounded-lg hover:bg-[#0B2A4A] transition-colors cursor-pointer whitespace-nowrap text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="ri-phone-line mr-2"></i>
                Agendar Cita
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
